<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab :key="'list'" ripple>Listes d'envoi</v-tab>
		<v-tab :key="'add'" ripple>Ajouter</v-tab>
		<v-tab-item :key="'list'">
			<user-list-list ref="list" :url="'userLists?filter=bot:$eq:'+$route.params.botId">
			</user-list-list>
		</v-tab-item>

		<v-tab-item :key="'add'">
			<user-list-form v-model="document" v-on:userListCreated="updateList">
			</user-list-form>
		</v-tab-item>
	</v-tabs>

</div>
</template>

<script>
import UserListList from '../../components/userLists/userList.list'
import UserListForm from '../../components/userLists/userList.form'

export default {
	data() {
		return {
			document: null
		}
	},
	methods: {
		updateList() {
			this.$refs.list.update()
		}
	},
	components: { UserListList, UserListForm }
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/userLists/userList.list.vue